var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-2"},[_c('b-button',{attrs:{"variant":"primary"},on:{"click":function($event){$event.stopPropagation();return _vm.confirmarInserirDetalhe()}}},[_c('i',{staticClass:"fa fa-plus mr-2"}),_vm._v(" Inserir detalhes em Lote\n    ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }